module.exports = __webpack_public_path__ + "img/bg_zq.29ada3be.png";